module.exports = __webpack_public_path__ + "img/merit2.49fef3f1.jpg";